import { useQuery } from "@tanstack/react-query";
import { getRelatedTours } from "@/utils/queries";

const useRelatedToursData = (id: string, isPremium: boolean) => {
    const { data: tours } = useQuery({
        queryKey: ["relatedTours", id],
        queryFn: () => getRelatedTours(id),
        enabled: !!id,
    });

    return isPremium ? tours?.premium : tours?.quality;
};

export default useRelatedToursData;
